module.exports = __webpack_public_path__ + "img/home-background-v3.9ce66d75.png";